import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const I32Guard = createFeatureGuard(Feature.Transformation);